module.exports = {
    /**
     * @description 网站标题
     */
    title: 'TP-LINK 实名认证中心',
    /**
     * @description 是否显示 tagsView
     */
    tagsView: true,
    /**
     * @description 固定头部
     */
    fixedHeader: true,
    /**
     * @description 记住密码状态下的token在Cookie中存储的天数，默认1天
     */
    tokenCookieExpires: 1,
    /**
     * @description 记住密码状态下的密码在Cookie中存储的天数，默认1天s
     */
    passCookieExpires: 1,
    /**
     * @description token key
     */
    TokenKey: 'Account-Token',
    /**
     * @description 请求超时时间，毫秒（默认2分钟）
     */
    timeout: 1200000,
    /**
     * @description 是否显示logo
     */
    sidebarLogo: true,
    /**
     * @description 是否显示设置的底部信息
     */
    showFooter: true,
    /**
     * @description 底部文字，支持html语法
     */
    footerTxt: 'Copyright © TP-LINK Cloud.',
    /**
     * @description 服务器异常错误
     */
    serverErrorMsg: "服务器异常",
    /**
     * @description 信息提示类型: 成功
     */
    notifySuc: "success",
    /**
     * @description 信息提示类型: 警告
     */
    notifyWarn: "warning",
    /**
     * @description 信息提示类型: 失败
     */
    notifyErr: "error",
    /**
     * @description 实名认证成功
     */
    certifySuc: "实名认证成功",
    /**
     * @description 提交错误
     */
    submitErr: "提交的数据有误!",
    /**
     * @description 图片格式错误
     */
    picTypeErr: "上传图片只能是 JPG/JPEG/PNG 格式!",
    /**
     * @description 图片过大
     */
    picOutSize: "上传图片大小不能超过 2MB!",
    /**
     * @description Token 超时
     */
    tokenTimeout: -20652,
    /**
     * @description 错误码对应的错误提示
     */
    errorMsg: {
        '-20000': '服务器内部错误',
        '-20104': '参数不存在',
        '-20105': '参数类型不对',
        '-20107': '参数错误',
        '-20200': '邮箱地址格式错误',
        '-20201': '电话号码格式错误',
        '-20202': '真实姓名格式错误',
        '-20600': '账户名/密码错误',
        '-20601': '账户名与密码不匹配',
        '-20604': '账号既不是邮箱也不是手机',
        '-20607': '验证码错误',
        '-20610': '账户类型错误',
        '-20611': '账号删除中',
        '-20615': '密码格式错误，包括长度不符合要求',
        '-20661': '账号被锁定2小时',
        '-20662': '该设备验证码请求次数超限',
        '-20616': '新密码格式错误，包括长度不符合要求',
        '-20652': '登录超时',
        '-20676': '该IP单小时验证码请求次数超限',
        '-21001': '验证码失效',

        '-29301': '身份证认证失败',
        '-29302': '身份证图片信息和输入的不一致',
        '-29303': '企业证件认证失败',
        '-29304': '企业证件图片信息和输入的不一致',
        '-29305': '身份证过期',
        '-29306': '验证码错误，点击图片刷新重试',
        '-29307': '验证码ID错误',
        '-29308': '用户未成年',
        '-29309': '用户已经实名'
    }
}

